import * as React from "react"
import { useTranslation } from "react-i18next"

import DeleteButton from "Catalog/Edit/shared/components/CatalogToolbar/DeleteButton"
import NewButton from "Catalog/Edit/shared/components/CatalogToolbar/NewButton"
import CatalogToolbar from "Catalog/shared/components/CatalogToolbar"
import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import useEditor from "shared/hooks/useEditor"
import useNavigateNoUpdate from "shared/hooks/useNavigateNoUpdate"
import { IOptionList } from "shared/hubrise/models"

interface ToolbarProps {
  optionList?: IOptionList
}

const Toolbar = ({ optionList }: ToolbarProps): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigateNoUpdate()
  const { editor } = useEditor()
  const { catalogNavigation } = useCatalogNavigation()

  const handleCreate = (name: string): void => {
    const newOptionList = editor.optionList.add(optionList, { name }, { name: "Option" })
    navigate(catalogNavigation.editPath("option_list", newOptionList.id))
  }

  const handleDelete = (optionList: IOptionList): void => {
    navigate(catalogNavigation.editNextPath("option_lists"))
    editor.optionList.delete(optionList.id)
  }

  const commandActions = (
    <>
      <NewButton handleCreate={handleCreate} labelAndTitle={t("toolbar.new.option_list")} />
      <DeleteButton item={optionList} handleDelete={handleDelete} />
    </>
  )

  return <CatalogToolbar commandActions={commandActions} />
}

export default Toolbar
